export default "__VITE_ASSET__9yXIY9g8__"